import * as Scrivito from "scrivito";

import "./bentoGridWidget.scss";

Scrivito.provideComponent(
  "BentoItemWidget",
  Scrivito.connect(({ widget }) => {
    const wide = widget.get("wideStyle");
    const tall = widget.get("tallStyle");
    const target = widget.get("target");

    const className = [
      "bento-grid-item d-block h-100",
      `bg-${widget.get("boxStyle")}`,
      tall && "--tall",
      wide && "--wide",
      target && "--linked",
    ]
      .filter(Boolean)
      .join(" ");

    if (target) {
      return (
        <Scrivito.LinkTag to={target} className={className}>
          <Scrivito.ContentTag content={widget} attribute="content" />
        </Scrivito.LinkTag>
      );
    }

    return (
      <Scrivito.WidgetTag className={className}>
        <Scrivito.ContentTag content={widget} attribute="content" />
      </Scrivito.WidgetTag>
    );
  })
);
